import { Routes as Switch, Route } from 'react-router-dom';

import { Home } from '../pages/Home';
import { CadastroTransportadoraFreteApp } from '../pages/CadastroTransportadoraFreteApp';
import { AtualizaCadastroOnsupply } from '../pages/AtualizaCadastroOnsupply';

function Routes(): JSX.Element {
  return (
    <Switch>
      <Route path="/" element={<CadastroTransportadoraFreteApp />} />
      <Route path="/atualizar-transportadora/:guid" element={<AtualizaCadastroOnsupply />} />
      <Route path="*" element={<CadastroTransportadoraFreteApp />} />
    </Switch>
  );
}

export { Routes };
